<template>
  <div class="contact">
    <ul v-if="!isComplete">
      <li>
        <div class="title">收货人</div>
        <input v-model="name" type="text" placeholder="名字" />
      </li>
      <li>
        <div class="title">联系人电话</div>
        <input
          v-model="phone"
          @input="phoneChange"
          type="text"
          placeholder="11位手机号码"
          pattern="\d*"
        />
      </li>
      <li @click="isShowPicker = true">
        <div class="title">所在地区</div>
        <div class="input" :class="{ dis: !addr }">
          {{ addr || '地区信息' }}
        </div>
        <div class="tip">
          请选择
          <img src="../assets/images/arr.png" />
        </div>
      </li>
      <li>
        <div class="title">详细地址</div>
        <input v-model="detail" type="text" placeholder="详细街道门牌信息" />
      </li>
    </ul>
    <div v-if="!isComplete" class="button" @click="submit">确认</div>
    <div v-if="isComplete" class="compelet">
      <img src="../assets/images/sub_compelet.png" alt />
      <p>
        恭喜您，您的邮寄信息已提交成功
        <br />感谢你对货拉拉的支持！
      </p>
      <div @click="back" class="button">关闭</div>
    </div>
    <addrPicker
      :isShowPicker="isShowPicker"
      @cancel="pickerCancel"
      @ok="pickerConfirm"
    ></addrPicker>
  </div>
</template>
<script>
import { verifyPhone, getUrlParam } from '@/utils';
export default {
  data() {
    return {
      isShowPicker: false, //是否展示地址选择器
      addr: '',
      name: '',
      phone: '',
      detail: ''
    };
  },
  props: {
    isComplete: {
      type: Boolean,
      default: false
    },
    storedData: {
      type: Object,
      default: null
    }
  },
  watch: {
    isShowPicker(value) {
      if (value) {
        this.closeTouch();
      } else {
        this.openTouch();
      }
    },
    storedData(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.setStoredData(newVal);
      }
    }
  },
  computed: {
    canSub() {
      return this.addr && this.name && this.phone && this.detail;
    }
  },
  beforeDestroy() {
    this.openTouch();
  },
  created() {
    this.$emit('getStoredData');
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    handler: function(e) {
      e.preventDefault();
    },
    phoneChange() {
      this.phone = this.phone.replace(/[^0-9]/g, '').slice(0, 11);
    },
    closeTouch() {
      console.log('closeTouch');
      document
        .getElementsByTagName('body')[0]
        .addEventListener('touchmove', this.handler, { passive: false }); //阻止默认事件
    },
    openTouch() {
      document
        .getElementsByTagName('body')[0]
        .removeEventListener('touchmove', this.handler, { passive: false }); //打开默认事件
    },
    pickerCancel() {
      this.isShowPicker = false;
    },
    pickerConfirm(addr) {
      this.addr = addr;
      this.isShowPicker = false;
    },
    submit() {
      if (!this.canSub) {
        this.$hll.toast('请完善收货信息');
      } else {
        if (
          verifyPhone(this.phone) &&
          this.verifyRecipient(this.name) &&
          this.verifyAddressDetail(this.detail)
        ) {
          this.infoSub();
        }
      }
    },
    verifyRecipient(name) {
      if (!name) {
        return false;
      }
      const note = '收货人长度需要在2～25个字符之间';
      if (name.length < 2 || name.length > 25) {
        this.$hll.toast(note);
        return false;
      }
      return true;
    },
    verifyAddressDetail(addressDetail) {
      if (!addressDetail) {
        return false;
      }
      const note = '详细地址长度需要在5～120个字符之间';
      if (addressDetail.length < 5 || addressDetail.length > 120) {
        this.$hll.toast(note);
        return false;
      }
      return true;
    },
    infoSub() {
      const addressArr = this.addr.split(/\s+/);
      this.$emit('submitAddress', {
        source: this.$route.query.uuid || getUrlParam('uuid'),
        addressee: this.name,
        phone: this.phone,
        province: addressArr[0],
        city: addressArr[1],
        county: addressArr[2],
        addressDetails: this.detail
      });
    },
    setStoredData(data) {
      this.addr = [
        data.province || '',
        data.city || '',
        data.county || ''
      ].join(' ');
      this.name = data.addressee;
      this.phone = data.tel;
      this.detail = data.addressDetail;
    }
  }
};
</script>
<style lang="less" scoped>
.contact {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ul {
    width: 100%;
    padding: 0 32px;
    box-sizing: border-box;

    li {
      height: 96px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgb(197, 197, 197);

      .title {
        width: 176px;
        font-size: 26px;
        font-weight: 400;
        color: rgba(21, 21, 21, 1);
      }

      input {
        width: 369px;
        font-size: 26px;
        font-weight: 400;
        color: rgba(21, 21, 21, 1);

        &::-webkit-input-placeholder {
          font-size: 26px;
          font-weight: 400;
          color: rgba(145, 145, 145, 1);
        }
      }

      .input {
        width: 369px;
        font-size: 26px;
        font-weight: 400;
        color: rgba(21, 21, 21, 1);

        &.dis {
          color: rgba(145, 145, 145, 1);
        }
      }

      .tip {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 150px;
        font-size: 26px;
        font-weight: 400;
        color: rgba(145, 145, 145, 1);

        img {
          flex-shrink: 0;
          width: 31px;
          height: 21px;
        }
      }
    }
  }

  .button {
    margin-top: 97px;
    width: 624px;
    height: 96px;
    background: #f16622;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    font-weight: 500;
    color: #fff;
  }

  .compelet {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      margin-top: 74px;
      height: 185px;
      width: 191px;
    }

    p {
      margin-top: 61px;
      font-size: 32px;
      font-weight: 400;
      color: rgba(45, 45, 45, 1);
      line-height: 46px;
      text-align: center;
    }

    .button {
      margin-top: 39px;
    }
  }
}
</style>
